<template>
  <div class="w-90">
    <b-card bg-variant="light">
      <h1 id="jump-to-header">{{heading || generated_heading + " Update"}}</h1>
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-warning"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
        lazy
      >
        <b-tab title="Settings" active>
          <collection-update
            :id="id"
            @gotAttrs="assignAttrs"
          ></collection-update>
        </b-tab>
        <b-tab title="Inventory">
          <product-item-index
            :filtering="filtering"
            :ams_template="ams_product_item_template"
          ></product-item-index>
        </b-tab>
        <b-tab title="Images">
          <collection-image-index
            :filtering="filtering"
            :ams_template="ams_collection_image_template"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import CollectionUpdate from './CollectionUpdate.vue'
import CollectionImageIndex from './CollectionImageIndex.vue'
import ProductItemIndex from './ProductItemIndex.vue'

export default {
  components: {
    CollectionUpdate,
    CollectionImageIndex,
    ProductItemIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        collection_ids: this.id
      },
      ams_product_item_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': undefined,
          'storage-space-id': undefined,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
      ams_collection_image_template: {
        type: 'collection-images',
        description: undefined,
        attributes: {
          'collection-id': this.id,
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
      this.ams_product_item_template.description = description
      // this.ams_product_item_template['storage-space-id'] = IdByStorageSpaceLocation(this.id)
      // Requires getting Storage Space by location of collection-id
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>